export default __webpack_public_path__ + "static/media/pencilcase.3593fa36.ogg";